module.exports = __webpack_public_path__ + "img/arrow.087ba1a1.svg";